module.exports = __webpack_public_path__ + "img/Misc_Email_Round.96dcf625.svg";